import React from 'react';
import './Box.css';

const Box = ({ className, title, children, footer }) => (
  <div className={ `box page-break-inside-avoid${ className ? ' ' + className : '' }` }>
    { title &&
      <div className="box-header">
        <h3 className="box-title">{ title }</h3>
      </div>
    }
    <div className="box-body">
      { children }
    </div>
    { footer &&
      <div className="box-footer">{ footer }</div>
    }
  </div>
);

export default Box;



// WEBPACK FOOTER //
// ./src/components/Box/Box.js